import React from 'react';

import { Box, Typography } from '@mui/material';

import { getConditionalObject } from 'utils/data';

import {
  getCicActionsColumn,
  getCicCommentColumnWidth,
  renderChangeCell,
  renderCommentCell,
  renderEnteredByCell,
} from '../../LoanCicHistory.config';
import { CicRemovalCauseLabel } from '../../LoanCicHistory.constants';
import { getWrappingCellStyles } from '../../LoanCicHistory.styles';
import { LoanCicHistoryTestIds } from '../../LoanCicHistory.testIds';
import CicReasonCell from '../CicReasonCell';

import { CicChangeColumnId } from './CicChangesTable.constants';
import { fieldCellStyles } from './CicChangesTable.styles';

const renderFieldCell = change => (
  <Box sx={fieldCellStyles}>
    <Typography variant="medium14">{change.label || change.field}</Typography>
    {!!CicRemovalCauseLabel[change.removalCause] && (
      <Typography color="text.secondary" variant="regular12">
        {CicRemovalCauseLabel[change.removalCause]}
      </Typography>
    )}
  </Box>
);

const getIsChangeEditable = ({ change, isEditAllowed }) => isEditAllowed && !!change.editable;

const renderReasonCell =
  ({ isEditAllowed, onOpenHistory }) =>
  change => (
    <CicReasonCell
      change={change}
      isHistoryLinkVisible={!getIsChangeEditable({ change, isEditAllowed })}
      onOpenHistory={onOpenHistory}
    />
  );

export const getCicChangesTableConfig = ({ hasActions, isEditAllowed, onEdit, onOpenHistory }) => ({
  [CicChangeColumnId.FIELD]: {
    label: 'Field',
    width: '15%',
    customStyles: getWrappingCellStyles,
    content: renderFieldCell,
  },
  [CicChangeColumnId.CHANGE]: {
    label: 'Change',
    width: '19%',
    customStyles: getWrappingCellStyles,
    content: renderChangeCell,
  },
  [CicChangeColumnId.REASON]: {
    label: 'Reason',
    width: '22%',
    customStyles: getWrappingCellStyles,
    content: renderReasonCell({ isEditAllowed, onOpenHistory }),
  },
  [CicChangeColumnId.COMMENT]: {
    label: 'Comment',
    width: getCicCommentColumnWidth(hasActions),
    customStyles: getWrappingCellStyles,
    content: renderCommentCell,
  },
  [CicChangeColumnId.ENTERED_BY]: {
    label: 'Entered by',
    width: '18%',
    customStyles: getWrappingCellStyles,
    content: renderEnteredByCell,
  },
  ...getConditionalObject(hasActions, () => ({
    [CicChangeColumnId.ACTIONS]: getCicActionsColumn({
      getIsEditable: change => getIsChangeEditable({ change, isEditAllowed }),
      getDataTestId: LoanCicHistoryTestIds.getChangeEditButtonId,
      onEdit,
    }),
  })),
});
